
    import './styles.scoped.css';
    export default {
  "key-value-pairs": "awsui_key-value-pairs_1y9fy_1wi7u_145",
  "group-title": "awsui_group-title_1y9fy_1wi7u_177",
  "group-list": "awsui_group-list_1y9fy_1wi7u_181",
  "group-list-item": "awsui_group-list-item_1y9fy_1wi7u_191",
  "term": "awsui_term_1y9fy_1wi7u_195",
  "key-label": "awsui_key-label_1y9fy_1wi7u_203",
  "detail": "awsui_detail_1y9fy_1wi7u_212",
  "info": "awsui_info_1y9fy_1wi7u_247"
};
  